import React from 'react';
import DataDrivenGuidePage from '../../components/guides/DataDrivenGuidePage';

const VoltageDropCalculatorGuidePage = () => <DataDrivenGuidePage slug="guide-voltage-drop-calculator" />;

export default VoltageDropCalculatorGuidePage;
